<div class="main-div">
  <div></div>

  <div class="main-header">Race has<br />started</div>

  <div class="break"></div>

  <div class="main-text">Find all the details of the race below</div>
  <div class="break"></div>
  <mat-card class="card">
    <mat-card-content>
      <div class="event-name-text">{{ event_name }}</div>
      <div class="card-header">The race was started on</div>
      <div class="card-header">
        <strong>{{ event_start_time }}</strong>
      </div>
      <hr />
      <div class="card-header">Timekeeper</div>
      <div class="card-header">
        <strong>{{ event_starter }}</strong>
      </div>



      
    </mat-card-content>
    <mat-card-actions
      >
      <button
        mat-raised-button
        color="primary"
        type="button"
        class="black-button"
        (click)="restart_race()"
      >
        Restart this race
      </button><div class="spacer"></div></mat-card-actions
    ></mat-card
  >  <div class="break"></div>
  <div class="spacer"></div>
  <div class="main-text">Scan people at the finish line.</div><div class="break"></div>
  <button
  mat-raised-button
  color="primary"
  type="button"
  class="pink-button"
  (click)="goto_finishline()"
>
  Go to finish line
</button>
  <div class="break"></div>
  <div class="spacer"></div>
</div>
